interface Option {
  value: string;
  label: string;
}

interface GroupedOption {
  groupName: string;
  options: Option[];
}

interface DropdownSelectProps {
  id: string;
  label: string;
  value: string;
  options: Option[] | GroupedOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

function RenderOption({ option }: { option: Option }): React.JSX.Element {
  return (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  );
}

export function DropdownSelect(props: DropdownSelectProps): React.JSX.Element {
  return (
    <label htmlFor={props.id}>
      {props.label}
      <select
        id={props.id}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disabled}
      >
        {props.options.map((option, index) => {
          if ('groupName' in option) {
            return (
              <optgroup
                // eslint-disable-next-line react/no-array-index-key
                key={`${option.groupName}-${index}`}
                label={option.groupName}
              >
                {option.options.map((opt, i) => (
                  <RenderOption
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${opt.value}-${i}`}
                    option={opt}
                  />
                ))}
              </optgroup>
            );
          }

          return <RenderOption key={option.value} option={option} />;
        })}
      </select>
    </label>
  );
}
